import { render, staticRenderFns } from "./MensagemEncerramento.vue?vue&type=template&id=2738a126&scoped=true"
import script from "./MensagemEncerramento.vue?vue&type=script&lang=js"
export * from "./MensagemEncerramento.vue?vue&type=script&lang=js"
import style0 from "./MensagemEncerramento.vue?vue&type=style&index=0&id=2738a126&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2738a126",
  null
  
)

export default component.exports